export default __webpack_public_path__ + "static/media/breadcrumb.102c3c1d.png";